import { useQuery } from "@tanstack/react-query";
import DealApi from "../api/DealApi";

export const useDealsData = ({
  page,
  limit,
  queryString = "",
  queryParams = "",
  ofCompany,
  sort = "-leadToDealOn",
  enabled = true,
}) => {
  const { data, isLoading, isError, error, isFetching, refetch } = useQuery({
    queryKey: ["deals", page, limit, queryString, queryParams, ofCompany, sort],
    queryFn: () =>
      DealApi.fetchDeals({
        page,
        limit,
        queryString,
        queryParams,
        ofCompany,
        populate: "ofCompany,assignedTo",
        selectPopulate: "name",
        sort,
      }),
    enabled,
    keepPreviousData: true, // Retain previous data during fetching
    staleTime: 30 * 1000,
    cacheTime: 30 * 1000,
    // refetchInterval: 30000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return { data, isLoading, isError, error, isFetching, refetch };
};
